import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../../util/axios";
const JixiaoList = styled.div`
  .month {
    background-color: #fff;
    padding: 10px 20px 10px 20px;
  }
  .month ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .month li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .month p {
    display: flex;
    justify-content: space-between;
  }
`;
interface Array1 {
  beTestedDepartmentCode: string;
  workQuality: string;
  managementPerformance: string;
  vSheetId: string;
  uuid: string;
}
export default function OrganizationAssessment() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const tabs = [{ title: "未考核" }, { title: "已考核" }];
  const [staffList, setStaffListt] = useState<Array1[]>([]);
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    console.log(tstr);
    instance
      .post(
        `/oa/examYear/getExecuteYearDepartList?permissionType=departMe&type=departFunction&vSheetId=` +
          tstr
      )
      .then((resp) => {
        // console.log(resp.data.Data.data);
        // console.log(resp);
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearDepartList?permissionType=departMe&type=departBusiness&vSheetId=` +
                tstr
            )
            .then((resp) => {
              // console.log(resp.data.Data.data);
              // console.log(resp);
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                console.log(arr);
                setStaffListt(arr);
              }
            });
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.go(-1);
                }}
              />
            }
          >
            组织绩效考核
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 未考核 */}
            <div className="month">
              <ul>
                {staffList.map((item) =>
                  !item.managementPerformance ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/jxassessment/yearassessment/organization/details?vSheetId=" +
                          item.vSheetId +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>
                          {item.beTestedDepartmentCode.substring(
                            0,
                            item.beTestedDepartmentCode.indexOf("c")
                          )}
                        </span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
            </div>
            {/* 已考核 */}
            <div className="month">
              <ul>
                {staffList.map((item) =>
                  item.managementPerformance ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/jxassessment/yearassessment/organization/details?vSheetId=" +
                          item.vSheetId +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>
                          {item.beTestedDepartmentCode.substring(
                            0,
                            item.beTestedDepartmentCode.indexOf("c")
                          )}
                        </span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
            </div>
          </Tabs>
        </div>
      </JixiaoList>
    </>
  );
}
